/**
 * @generated SignedSource<<dd4804d90c66dc273e7773242a9f1678>>
 * @relayHash a3f2d72ebd50b43cf2241f114e41873c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 38eff953d5dc19b03e72c037d9f32dea3993ff719f8d7d1d780dac76ea6d62a5

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAtlassianIntelligenceFeatureEnum = "AI_MATE" | "NATURAL_LANGUAGE_TO_JQL" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraIssueSearchViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraIssueSearchViewProjectKeyAndItemIdQuery | null | undefined;
  viewAri?: string | null | undefined;
};
export type JiraIssueSearchViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type main_IssueNavigatorQuery$variables = {
  after?: string | null | undefined;
  amountOfColumns: number;
  atlassianIntelligenceProductFeature: JiraAtlassianIntelligenceFeatureEnum;
  before?: string | null | undefined;
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  fieldSetsContext?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  fieldSetsScope?: JiraIssueSearchScope | null | undefined;
  filterId?: string | null | undefined;
  first?: number | null | undefined;
  groupBy?: string | null | undefined;
  isPaginating?: boolean | null | undefined;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  namespace?: string | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey: string;
  scope?: JiraIssueSearchScope | null | undefined;
  shouldQueryFieldSetsById: boolean;
  shouldQueryHasChildren?: boolean | null | undefined;
  shouldQueryProject: boolean;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
  viewId?: string | null | undefined;
  viewQueryInput?: JiraIssueSearchViewQueryInput | null | undefined;
};
export type main_IssueNavigatorQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey?: {
      readonly " $fragmentSpreads": FragmentRefs<"issueSearch_issueNavigatorProject" | "main_issueNavigator_IssueNavigatorUI_project">;
    } | null | undefined;
    readonly userPreferences: {
      readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_userPreferences">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_jira">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_issueQuery">;
};
export type main_IssueNavigatorQuery = {
  response: main_IssueNavigatorQuery$data;
  variables: main_IssueNavigatorQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": isRefactorNinToViewSchemaEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": bulkOpsInNinEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": isIssueRankingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": isCheckIssueCreatePermissionsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import bulkOpsInNinEnabled_provider from '@atlassian/jira-relay-provider/src/is-bulk-ops-in-nin-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isRefactorNinToViewSchemaEnabled_provider from '@atlassian/jira-relay-provider/src/is-refactor-nin-to-view-schema-enabled.relayprovider';
import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isSavedListViewEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-enabled.relayprovider';
import isSavedListViewTechnicalChangesEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-technical-changes-enabled.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isCheckIssueCreatePermissionsEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-check-issue-create-permissions.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isIssueRankingEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-issue-ranking.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianIntelligenceProductFeature"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsContext"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsScope"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPaginating"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldSetsById"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryProject"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewQueryInput"
},
v26 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v27 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v28 = [
  (v27/*: any*/)
],
v29 = [
  (v27/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v30 = {
  "kind": "ScalarField",
  "name": "__id"
},
v31 = {
  "kind": "ClientExtension",
  "selections": [
    (v30/*: any*/)
  ]
},
v32 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "feature",
        "variableName": "atlassianIntelligenceProductFeature"
      }
    ],
    "kind": "ObjectValue",
    "name": "atlassianIntelligenceProductFeatureInput"
  },
  (v27/*: any*/)
],
v33 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v34 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v35 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v36 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v37 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v38 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v39 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v40 = {
  "kind": "Variable",
  "name": "options",
  "variableName": "options"
},
v41 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v42 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
},
v43 = [
  (v34/*: any*/),
  (v35/*: any*/),
  (v27/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v45 = {
  "kind": "ScalarField",
  "name": "id"
},
v46 = {
  "kind": "ScalarField",
  "name": "key"
},
v47 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v48 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v49 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v50 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v51 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v50/*: any*/),
    (v45/*: any*/)
  ]
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v49/*: any*/),
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v51/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v53 = {
  "args": [
    {
      "kind": "Literal",
      "name": "ids",
      "value": [
        "status"
      ]
    }
  ],
  "concreteType": "JiraIssueFieldConnection",
  "kind": "LinkedField",
  "name": "fieldsById",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueFieldEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v33/*: any*/),
            (v52/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldsById(ids:[\"status\"])"
},
v54 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v55 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v54/*: any*/),
        (v45/*: any*/)
      ]
    },
    (v45/*: any*/)
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "name"
},
v57 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueTypeField",
      "kind": "LinkedField",
      "name": "issueTypeField",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            (v56/*: any*/)
          ]
        }
      ]
    }
  ]
},
v58 = {
  "kind": "ClientExtension",
  "selections": [
    (v30/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isHighlightedIssueRow"
    }
  ]
},
v59 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "amountOfColumns"
},
v60 = {
  "kind": "ScalarField",
  "name": "type"
},
v61 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v62 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraIssueField"
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v56/*: any*/),
                (v45/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v64 = {
  "kind": "ScalarField",
  "name": "value"
},
v65 = [
  (v64/*: any*/),
  (v45/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v66 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v67 = {
  "kind": "ClientExtension",
  "selections": [
    (v66/*: any*/)
  ]
},
v68 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v69 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v70 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v71 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v72 = {
  "kind": "ScalarField",
  "name": "text"
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    (v56/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v74 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v75 = [
  (v74/*: any*/)
],
v76 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v45/*: any*/)
  ]
},
v77 = [
  (v76/*: any*/)
],
v78 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v79 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v64/*: any*/)
  ]
},
v80 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v81 = {
  "kind": "ScalarField",
  "name": "picture"
},
v82 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v83 = [
  (v45/*: any*/)
],
v84 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraCascadingOption",
          "kind": "LinkedField",
          "name": "cascadingOption",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "parentOptionValue",
              "plural": false,
              "selections": (v65/*: any*/)
            },
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "childOptionValue",
              "plural": false,
              "selections": (v65/*: any*/)
            }
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraCascadingSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "args": (v68/*: any*/),
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v69/*: any*/),
                    (v70/*: any*/),
                    (v45/*: any*/)
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedComponentsConnection(first:1000)"
        },
        (v67/*: any*/)
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v71/*: any*/),
        (v56/*: any*/),
        (v67/*: any*/)
      ],
      "type": "JiraDateTimePickerField"
    },
    (v73/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraCommentSummary",
          "kind": "LinkedField",
          "name": "commentSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canAddComment"
            },
            (v74/*: any*/)
          ]
        }
      ],
      "type": "JiraCommentSummaryField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "kind": "ScalarField",
          "name": "uri"
        },
        (v67/*: any*/)
      ],
      "type": "JiraUrlField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "fieldOptions",
          "plural": false,
          "selections": (v75/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "fieldOption",
          "plural": false,
          "selections": [
            (v64/*: any*/),
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v77/*: any*/)
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v77/*: any*/)
            },
            (v45/*: any*/),
            (v78/*: any*/)
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraSingleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraOption",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v45/*: any*/),
                    (v64/*: any*/),
                    (v78/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraMultipleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v79/*: any*/)
              ]
            }
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraCheckboxesField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraUserConnection",
          "kind": "LinkedField",
          "name": "selectedUsersConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v33/*: any*/),
                    (v80/*: any*/),
                    (v56/*: any*/),
                    (v81/*: any*/),
                    (v45/*: any*/),
                    (v82/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "email"
                        }
                      ],
                      "type": "AtlassianAccountUser"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraMultipleSelectUserPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraTeamView",
          "kind": "LinkedField",
          "name": "selectedTeam",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedId"
            },
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedName"
            }
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraTeamViewField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                {
                  "concreteType": "JiraEstimate",
                  "kind": "LinkedField",
                  "name": "originalEstimate",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "timeInSeconds"
                    }
                  ]
                },
                {
                  "concreteType": "JiraTimeTrackingSettings",
                  "kind": "LinkedField",
                  "name": "timeTrackingSettings",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "workingHoursPerDay"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "workingDaysPerWeek"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultFormat"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultUnit"
                    }
                  ]
                },
                (v49/*: any*/),
                (v56/*: any*/),
                (v60/*: any*/),
                (v67/*: any*/)
              ]
            },
            (v45/*: any*/)
          ]
        }
      ],
      "type": "JiraOriginalTimeEstimateField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "selectedOption",
          "plural": false,
          "selections": [
            {
              "alias": "label",
              "kind": "ScalarField",
              "name": "value"
            },
            (v45/*: any*/),
            (v69/*: any*/)
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraRadioSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "args": (v68/*: any*/),
          "concreteType": "JiraVersionConnection",
          "kind": "LinkedField",
          "name": "selectedVersionsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraVersionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraVersion",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v45/*: any*/),
                    (v56/*: any*/),
                    (v69/*: any*/),
                    (v70/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "versionId"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedVersionsConnection(first:1000)"
        },
        (v67/*: any*/)
      ],
      "type": "JiraMultipleVersionPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": (v83/*: any*/)
        },
        {
          "args": (v68/*: any*/),
          "concreteType": "JiraGoalConnection",
          "kind": "LinkedField",
          "name": "selectedGoals",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v45/*: any*/),
                    (v46/*: any*/)
                  ]
                }
              ]
            },
            (v31/*: any*/)
          ],
          "storageKey": "selectedGoals(first:1000)"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            (v30/*: any*/),
            (v66/*: any*/)
          ]
        }
      ],
      "type": "JiraGoalsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "args": (v68/*: any*/),
          "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
          "kind": "LinkedField",
          "name": "confluenceRemoteIssueLinks",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraConfluenceRemoteIssueLink",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v45/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "href"
                    }
                  ]
                }
              ]
            },
            (v74/*: any*/)
          ],
          "storageKey": "confluenceRemoteIssueLinks(first:1000)"
        },
        (v67/*: any*/)
      ],
      "type": "JiraConfluenceRemoteIssueLinksField"
    }
  ]
},
v85 = {
  "kind": "ScalarField",
  "name": "message"
},
v86 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            (v85/*: any*/)
          ]
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v87 = [
  (v56/*: any*/),
  (v45/*: any*/)
],
v88 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "componentsOld",
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v87/*: any*/)
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v72/*: any*/)
      ],
      "type": "JiraSingleLineTextField"
    }
  ]
},
v89 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "date"
    },
    (v56/*: any*/),
    (v89/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v71/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v92 = {
  "kind": "ScalarField",
  "name": "summary"
},
v93 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        (v46/*: any*/),
        (v92/*: any*/),
        {
          "kind": "ScalarField",
          "name": "color"
        },
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraEpicLinkField"
},
v94 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v95 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        (v50/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v96 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        (v51/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v97 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v68/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v56/*: any*/),
                (v76/*: any*/)
              ]
            }
          ]
        },
        (v74/*: any*/)
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v56/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v98 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v99 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v98/*: any*/),
        (v56/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v100 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v72/*: any*/),
    (v45/*: any*/)
  ]
},
v101 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v76/*: any*/),
    (v45/*: any*/)
  ]
},
v102 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v103 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v102/*: any*/),
        (v56/*: any*/),
        (v45/*: any*/)
      ]
    },
    (v45/*: any*/)
  ]
},
v104 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v46/*: any*/),
        (v100/*: any*/),
        (v45/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v46/*: any*/),
            (v101/*: any*/),
            (v103/*: any*/),
            (v100/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v46/*: any*/),
            (v101/*: any*/),
            (v103/*: any*/),
            (v100/*: any*/),
            (v45/*: any*/),
            (v47/*: any*/),
            (v104/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "summary",
                    "issuetype",
                    "status"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v33/*: any*/),
                        (v45/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v49/*: any*/),
                            (v72/*: any*/)
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v49/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "issueTypeId"
                                },
                                (v56/*: any*/),
                                (v102/*: any*/),
                                (v54/*: any*/),
                                (v45/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        (v52/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
            }
          ]
        },
        (v56/*: any*/),
        (v67/*: any*/)
      ]
    }
  ],
  "type": "JiraParentIssueField"
},
v106 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        (v106/*: any*/),
        (v45/*: any*/)
      ]
    },
    (v56/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v108 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        (v46/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v109 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v87/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v110 = [
  (v45/*: any*/),
  {
    "kind": "ScalarField",
    "name": "sprintId"
  },
  (v56/*: any*/),
  {
    "kind": "ScalarField",
    "name": "state"
  },
  {
    "kind": "ScalarField",
    "name": "endDate"
  }
],
v111 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v110/*: any*/)
            }
          ]
        }
      ]
    },
    (v56/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraSprintField"
},
v112 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        (v80/*: any*/),
        (v81/*: any*/),
        (v56/*: any*/),
        (v45/*: any*/),
        (v82/*: any*/)
      ]
    },
    (v56/*: any*/),
    (v89/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v113 = {
  "kind": "InlineFragment",
  "selections": [
    (v56/*: any*/),
    {
      "args": (v68/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v87/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    }
  ],
  "type": "JiraMultipleVersionPickerField"
},
v114 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v115 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        (v102/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v116 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v74/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v104/*: any*/),
                    (v46/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v33/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v51/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v45/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    (v45/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v45/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v117 = {
  "kind": "ScalarField",
  "name": "number"
},
v118 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "formatStyle"
        },
        {
          "kind": "ScalarField",
          "name": "formatUnit"
        }
      ]
    }
  ]
},
v119 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v117/*: any*/),
    (v56/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        (v117/*: any*/),
        (v118/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v117/*: any*/),
        (v56/*: any*/),
        (v118/*: any*/),
        (v67/*: any*/)
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraNumberField"
},
v120 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "JiraGroupConnection",
          "kind": "LinkedField",
          "name": "selectedGroupsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v45/*: any*/),
                    (v56/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "groupId"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v67/*: any*/)
      ],
      "type": "JiraMultipleGroupPickerField"
    }
  ]
},
v121 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraFlag",
          "kind": "LinkedField",
          "name": "flag",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFlagged"
            }
          ]
        }
      ],
      "type": "JiraFlagField"
    }
  ]
},
v122 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraWatch",
          "kind": "LinkedField",
          "name": "watch",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "isWatching"
            }
          ]
        }
      ],
      "type": "JiraWatchesField"
    }
  ]
},
v123 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v75/*: any*/)
},
v124 = [
  {
    "concreteType": "JiraIssueFieldSetEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueFieldSet",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v60/*: any*/),
          (v61/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v49/*: any*/),
                      (v60/*: any*/),
                      (v62/*: any*/),
                      (v45/*: any*/),
                      (v63/*: any*/),
                      (v84/*: any*/),
                      (v86/*: any*/),
                      (v88/*: any*/),
                      (v90/*: any*/),
                      (v91/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/),
                      (v73/*: any*/),
                      (v95/*: any*/),
                      (v96/*: any*/),
                      (v97/*: any*/),
                      (v99/*: any*/),
                      (v105/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      (v109/*: any*/),
                      (v111/*: any*/),
                      (v112/*: any*/),
                      (v113/*: any*/),
                      (v114/*: any*/),
                      (v115/*: any*/),
                      (v116/*: any*/),
                      (v119/*: any*/),
                      (v120/*: any*/),
                      (v121/*: any*/),
                      (v122/*: any*/)
                    ]
                  }
                ]
              },
              (v123/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v125 = {
  "kind": "Variable",
  "name": "filterId",
  "variableName": "filterId"
},
v126 = {
  "kind": "Variable",
  "name": "namespace",
  "variableName": "namespace"
},
v127 = {
  "kind": "Variable",
  "name": "viewId",
  "variableName": "viewId"
},
v128 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "condition": "shouldQueryFieldSetsById",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "fieldSetIds",
              "variableName": "fieldSetIds"
            },
            (v59/*: any*/)
          ],
          "concreteType": "JiraIssueFieldSetConnection",
          "kind": "LinkedField",
          "name": "fieldSetsById",
          "plural": false,
          "selections": (v124/*: any*/)
        }
      ]
    },
    {
      "condition": "shouldQueryFieldSetsById",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "context",
              "variableName": "fieldSetsContext"
            },
            (v125/*: any*/),
            (v59/*: any*/),
            (v126/*: any*/),
            (v127/*: any*/)
          ],
          "concreteType": "JiraIssueFieldSetConnection",
          "kind": "LinkedField",
          "name": "fieldSetsForIssueSearchView",
          "plural": false,
          "selections": (v124/*: any*/)
        }
      ]
    }
  ]
},
v129 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    (v53/*: any*/),
    (v55/*: any*/),
    (v57/*: any*/),
    (v58/*: any*/),
    (v128/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v92/*: any*/),
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v98/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v130 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v131 = {
  "args": (v130/*: any*/),
  "concreteType": "JiraIssueFieldSetConnection",
  "kind": "LinkedField",
  "name": "fieldSets",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v60/*: any*/),
            (v61/*: any*/),
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v33/*: any*/),
                        (v49/*: any*/),
                        (v60/*: any*/),
                        (v62/*: any*/),
                        (v45/*: any*/),
                        (v63/*: any*/),
                        (v84/*: any*/),
                        (v86/*: any*/),
                        (v88/*: any*/),
                        (v90/*: any*/),
                        (v91/*: any*/),
                        (v93/*: any*/),
                        (v94/*: any*/),
                        (v73/*: any*/),
                        (v95/*: any*/),
                        (v96/*: any*/),
                        (v97/*: any*/),
                        (v99/*: any*/),
                        (v105/*: any*/),
                        (v107/*: any*/),
                        (v108/*: any*/),
                        (v109/*: any*/),
                        (v111/*: any*/),
                        (v112/*: any*/),
                        (v113/*: any*/),
                        (v114/*: any*/),
                        (v115/*: any*/),
                        (v116/*: any*/),
                        (v119/*: any*/),
                        (v120/*: any*/),
                        (v121/*: any*/),
                        (v122/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraOptionConnection",
                              "kind": "LinkedField",
                              "name": "selectedOptions",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraOptionEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v79/*: any*/),
                                    (v31/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraCheckboxesField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraOption",
                              "kind": "LinkedField",
                              "name": "fieldOption",
                              "plural": false,
                              "selections": [
                                (v78/*: any*/),
                                (v45/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraSingleSelectField"
                        },
                        (v31/*: any*/)
                      ]
                    }
                  ]
                },
                (v123/*: any*/)
              ]
            },
            (v31/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldSets(first:500)"
},
v132 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v133 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v134 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v132/*: any*/),
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    (v133/*: any*/),
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    }
  ]
},
v135 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "firstIssuePosition"
    },
    {
      "kind": "ScalarField",
      "name": "lastIssuePosition"
    }
  ]
},
v136 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v137 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v138 = [
  (v136/*: any*/),
  (v44/*: any*/),
  (v137/*: any*/)
],
v139 = {
  "args": [
    {
      "kind": "Literal",
      "name": "maxCursors",
      "value": 7
    }
  ],
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v138/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v138/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "first",
      "plural": false,
      "selections": [
        (v44/*: any*/),
        (v136/*: any*/),
        (v137/*: any*/)
      ]
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v140 = {
  "kind": "ScalarField",
  "name": "totalIssueSearchResultCount"
},
v141 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "messages"
        }
      ],
      "type": "JiraInvalidJqlError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v85/*: any*/),
        {
          "kind": "ScalarField",
          "name": "errorType"
        }
      ],
      "type": "JiraInvalidSyntaxError"
    }
  ]
},
v142 = {
  "kind": "ScalarField",
  "name": "jql"
},
v143 = {
  "kind": "ScalarField",
  "name": "isCappingIssueSearchResult"
},
v144 = [
  {
    "concreteType": "JiraIssueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v44/*: any*/),
      (v129/*: any*/),
      (v33/*: any*/),
      (v131/*: any*/),
      {
        "condition": "shouldQueryHasChildren",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "filterByProjectKeys.0",
                    "variableName": "projectKey"
                  }
                ],
                "kind": "ListValue",
                "name": "filterByProjectKeys"
              }
            ],
            "kind": "ScalarField",
            "name": "hasChildren"
          },
          {
            "args": [
              (v26/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "canHaveChildIssues"
          }
        ]
      },
      (v31/*: any*/)
    ]
  },
  (v134/*: any*/),
  (v135/*: any*/),
  (v139/*: any*/),
  (v140/*: any*/),
  (v141/*: any*/),
  (v142/*: any*/),
  (v143/*: any*/),
  (v31/*: any*/)
],
v145 = [
  "issueSearchInput"
],
v146 = {
  "kind": "ScalarField",
  "name": "viewId"
},
v147 = {
  "kind": "Variable",
  "name": "staticViewInput",
  "variableName": "staticViewInput"
},
v148 = [
  (v147/*: any*/)
],
v149 = {
  "kind": "ScalarField",
  "name": "hideDone"
},
v150 = {
  "args": (v148/*: any*/),
  "concreteType": "JiraIssueSearchViewConfigSettings",
  "kind": "LinkedField",
  "name": "viewConfigSettings",
  "plural": false,
  "selections": [
    (v149/*: any*/)
  ]
},
v151 = {
  "kind": "ScalarField",
  "name": "isHierarchyEnabled"
},
v152 = {
  "kind": "ScalarField",
  "name": "hasDefaultFieldSets"
},
v153 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  (v59/*: any*/),
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "fieldSetsScope"
  }
],
v154 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v155 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v156 = {
  "kind": "ScalarField",
  "name": "isSortable"
},
v157 = {
  "concreteType": "JiraFieldSetPreferences",
  "kind": "LinkedField",
  "name": "fieldSetPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "width"
    }
  ]
},
v158 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueSearchFieldMetadataConnection",
      "kind": "LinkedField",
      "name": "fieldsMetadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueSearchFieldMetadataEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueSearchMetadataField",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "canBeConfigured"
                },
                (v49/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v159 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isPlaceHolderField"
    }
  ]
},
v160 = {
  "concreteType": "JiraFieldType",
  "kind": "LinkedField",
  "name": "fieldType",
  "plural": false,
  "selections": [
    (v154/*: any*/)
  ]
},
v161 = {
  "kind": "ScalarField",
  "name": "canEnableHierarchy"
},
v162 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isSortedByGlobalRankOnly"
    }
  ]
},
v163 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v164 = [
  (v163/*: any*/),
  (v38/*: any*/),
  (v147/*: any*/)
],
v165 = {
  "concreteType": "JiraSpreadsheetGroupByConfig",
  "kind": "LinkedField",
  "name": "groupByConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraField",
      "kind": "LinkedField",
      "name": "groupByField",
      "plural": false,
      "selections": [
        (v49/*: any*/),
        (v45/*: any*/)
      ]
    }
  ]
},
v166 = {
  "kind": "ScalarField",
  "name": "isGroupingEnabled"
},
v167 = {
  "kind": "ScalarField",
  "name": "canEnableGrouping"
},
v168 = [
  (v151/*: any*/),
  (v161/*: any*/),
  (v166/*: any*/),
  (v167/*: any*/)
],
v169 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v164/*: any*/),
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": (v168/*: any*/)
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
},
v170 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "args": (v164/*: any*/),
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewSettings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canPublishViewConfig"
          },
          {
            "kind": "ScalarField",
            "name": "isViewConfigModified"
          }
        ]
      }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
  }
],
v171 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v170/*: any*/),
      "type": "JiraIssueSearchViewMetadata",
      "abstractKey": "__isJiraIssueSearchViewMetadata"
    }
  ]
},
v172 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ]
},
v173 = [
  (v172/*: any*/),
  (v85/*: any*/)
],
v174 = [
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/)
],
v175 = [
  (v34/*: any*/),
  (v35/*: any*/),
  (v37/*: any*/),
  (v163/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v41/*: any*/)
],
v176 = {
  "kind": "ScalarField",
  "name": "fieldType"
},
v177 = {
  "kind": "LinkedField",
  "name": "fieldValue",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            {
              "kind": "ScalarField",
              "name": "priorityId"
            },
            (v56/*: any*/),
            (v106/*: any*/)
          ]
        },
        (v154/*: any*/)
      ],
      "type": "JiraJqlPriorityFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v33/*: any*/),
            (v45/*: any*/),
            (v80/*: any*/),
            (v56/*: any*/),
            (v81/*: any*/)
          ]
        },
        (v154/*: any*/)
      ],
      "type": "JiraJqlUserFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v56/*: any*/),
            {
              "concreteType": "JiraStatusCategory",
              "kind": "LinkedField",
              "name": "statusCategory",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v50/*: any*/)
              ]
            }
          ]
        },
        (v154/*: any*/),
        (v51/*: any*/)
      ],
      "type": "JiraJqlStatusFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v117/*: any*/)
      ],
      "type": "JiraJqlNumberFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v78/*: any*/),
            (v64/*: any*/),
            (v76/*: any*/)
          ]
        },
        (v154/*: any*/)
      ],
      "type": "JiraJqlOptionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraSprint",
          "kind": "LinkedField",
          "name": "sprint",
          "plural": false,
          "selections": (v110/*: any*/)
        },
        (v154/*: any*/)
      ],
      "type": "JiraJqlSprintFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "kind": "ScalarField",
              "name": "score"
            }
          ]
        },
        (v154/*: any*/)
      ],
      "type": "JiraJqlGoalsFieldValue"
    }
  ]
},
v178 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v179 = [
  (v36/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v180 = [
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/)
],
v181 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "args": [
          (v26/*: any*/),
          {
            "items": [
              {
                "kind": "Variable",
                "name": "projectKeys.0",
                "variableName": "projectKey"
              }
            ],
            "kind": "ListValue",
            "name": "projectKeys"
          }
        ],
        "kind": "FragmentSpread",
        "name": "main_issueNavigator_IssueNavigator_issueQuery"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v28/*: any*/),
            "concreteType": "JiraUserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_IssueNavigator_userPreferences"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_jira"
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v29/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigatorUI_project"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "issueSearch_issueNavigatorProject"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v13/*: any*/),
      (v10/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v15/*: any*/),
      (v24/*: any*/),
      (v16/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v19/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v17/*: any*/),
      (v21/*: any*/),
      (v12/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v18/*: any*/),
      (v11/*: any*/),
      (v20/*: any*/),
      (v8/*: any*/),
      (v25/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v28/*: any*/),
            "concreteType": "JiraUserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "jqlBuilderSearchMode"
              },
              {
                "kind": "ScalarField",
                "name": "isNaturalLanguageSpotlightTourEnabled"
              },
              (v31/*: any*/)
            ]
          },
          {
            "args": (v32/*: any*/),
            "kind": "ScalarField",
            "name": "shouldShowAtlassianIntelligence"
          },
          {
            "args": (v32/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianIntelligenceAction",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAccessible"
                  }
                ],
                "type": "JiraAccessAtlassianIntelligenceFeature"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "link"
                  }
                ],
                "type": "JiraEnableAtlassianIntelligenceDeepLink"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v43/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearch",
                "plural": false,
                "selections": (v144/*: any*/)
              },
              {
                "args": (v43/*: any*/),
                "filters": (v145/*: any*/),
                "handle": "connection",
                "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                "kind": "LinkedHandle",
                "name": "issueSearch"
              },
              {
                "args": [
                  (v27/*: any*/),
                  (v125/*: any*/),
                  (v38/*: any*/),
                  (v126/*: any*/),
                  (v127/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "issueSearchViewResult",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraIssueSearchViewResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v146/*: any*/),
                      (v150/*: any*/),
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v148/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewConfigSettings",
                            "plural": false,
                            "selections": [
                              (v151/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v45/*: any*/),
                          (v152/*: any*/),
                          {
                            "args": (v153/*: any*/),
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                              (v74/*: any*/),
                              {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v60/*: any*/),
                                      (v154/*: any*/),
                                      (v155/*: any*/),
                                      (v156/*: any*/),
                                      (v157/*: any*/),
                                      (v158/*: any*/),
                                      (v159/*: any*/),
                                      (v160/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "args": (v148/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": [
                                      (v161/*: any*/),
                                      (v162/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraIssueSearchView"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "args": (v164/*: any*/),
                                "concreteType": "JiraIssueSearchViewConfigSettings",
                                "kind": "LinkedField",
                                "name": "viewSettings",
                                "plural": false,
                                "selections": [
                                  (v161/*: any*/),
                                  (v165/*: any*/),
                                  (v151/*: any*/),
                                  (v149/*: any*/),
                                  (v162/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSpreadsheetView",
                            "abstractKey": "__isJiraSpreadsheetView"
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isJiraIssueSearchViewMetadata"
                              },
                              (v45/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": (v148/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": [
                                      (v161/*: any*/),
                                      (v166/*: any*/),
                                      (v167/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraIssueSearchView"
                              },
                              (v169/*: any*/)
                            ]
                          },
                          (v31/*: any*/),
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": (v170/*: any*/)
                          }
                        ],
                        "type": "JiraIssueSearchViewMetadata",
                        "abstractKey": "__isJiraIssueSearchViewMetadata"
                      },
                      (v171/*: any*/)
                    ],
                    "type": "JiraIssueSearchView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v85/*: any*/),
                      (v172/*: any*/)
                    ],
                    "type": "QueryError"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v83/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v27/*: any*/),
                  (v125/*: any*/),
                  (v38/*: any*/),
                  (v126/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "viewConfigInput",
                    "variableName": "staticViewInput"
                  },
                  (v127/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "viewQueryInput",
                    "variableName": "viewQueryInput"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraIssueSearchView",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraView"
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "error",
                    "plural": false,
                    "selections": (v173/*: any*/)
                  },
                  (v45/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v146/*: any*/),
                      {
                        "args": (v153/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "JiraIssueSearchViewMetadata",
                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v164/*: any*/),
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                          (v166/*: any*/),
                          (v167/*: any*/),
                          {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "groupByField",
                                "plural": false,
                                "selections": [
                                  (v49/*: any*/),
                                  (v45/*: any*/),
                                  (v56/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                  }
                                ]
                              }
                            ]
                          },
                          (v151/*: any*/),
                          (v149/*: any*/)
                        ]
                      },
                      (v142/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "filterId"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v152/*: any*/),
                          {
                            "args": (v153/*: any*/),
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                              (v74/*: any*/),
                              {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v60/*: any*/),
                                      (v154/*: any*/),
                                      (v155/*: any*/),
                                      (v156/*: any*/),
                                      (v157/*: any*/),
                                      (v160/*: any*/),
                                      (v158/*: any*/),
                                      (v159/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": (v148/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": (v168/*: any*/)
                                  }
                                ],
                                "type": "JiraIssueSearchView"
                              },
                              (v169/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v150/*: any*/),
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "args": (v148/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": [
                                      (v151/*: any*/),
                                      (v161/*: any*/),
                                      (v149/*: any*/),
                                      (v162/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraIssueSearchView"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "args": (v164/*: any*/),
                                "concreteType": "JiraIssueSearchViewConfigSettings",
                                "kind": "LinkedField",
                                "name": "viewSettings",
                                "plural": false,
                                "selections": [
                                  (v149/*: any*/),
                                  (v161/*: any*/),
                                  (v165/*: any*/),
                                  (v151/*: any*/),
                                  (v162/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSpreadsheetView",
                            "abstractKey": "__isJiraSpreadsheetView"
                          },
                          (v31/*: any*/)
                        ],
                        "type": "JiraIssueSearchViewMetadata",
                        "abstractKey": "__isJiraIssueSearchViewMetadata"
                      },
                      (v171/*: any*/)
                    ],
                    "type": "JiraSpreadsheetView",
                    "abstractKey": "__isJiraSpreadsheetView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v174/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v44/*: any*/),
                              (v129/*: any*/),
                              (v33/*: any*/),
                              (v131/*: any*/),
                              (v31/*: any*/)
                            ]
                          },
                          (v134/*: any*/),
                          (v135/*: any*/),
                          (v139/*: any*/),
                          (v140/*: any*/),
                          (v141/*: any*/),
                          (v142/*: any*/),
                          (v143/*: any*/),
                          (v31/*: any*/)
                        ]
                      },
                      {
                        "args": (v174/*: any*/),
                        "filters": (v145/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorDetailedViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ],
                    "type": "JiraDetailedView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v175/*: any*/),
                        "concreteType": "JiraSpreadsheetGroupConnection",
                        "kind": "LinkedField",
                        "name": "groups",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraSpreadsheetGroupEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v44/*: any*/),
                              {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  (v45/*: any*/),
                                  (v142/*: any*/),
                                  (v49/*: any*/),
                                  (v176/*: any*/),
                                  (v177/*: any*/),
                                  (v178/*: any*/)
                                ]
                              },
                              (v33/*: any*/)
                            ]
                          },
                          (v134/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "groupByField"
                          },
                          (v142/*: any*/),
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": (v173/*: any*/)
                          },
                          {
                            "condition": "isPaginating",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  {
                                    "args": (v179/*: any*/),
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          (v33/*: any*/),
                                          (v44/*: any*/),
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v33/*: any*/),
                                              (v45/*: any*/),
                                              (v46/*: any*/),
                                              (v47/*: any*/),
                                              (v48/*: any*/),
                                              (v53/*: any*/),
                                              (v55/*: any*/),
                                              (v57/*: any*/),
                                              (v58/*: any*/),
                                              (v128/*: any*/)
                                            ]
                                          },
                                          {
                                            "args": (v130/*: any*/),
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": (v124/*: any*/),
                                            "storageKey": "fieldSets(first:500)"
                                          },
                                          (v31/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                          (v132/*: any*/),
                                          (v133/*: any*/)
                                        ]
                                      },
                                      (v140/*: any*/),
                                      (v143/*: any*/),
                                      (v31/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": (v179/*: any*/),
                                    "filters": [
                                      "fieldSetsInput"
                                    ],
                                    "handle": "connection",
                                    "key": "firstGroupSection_nativeIssueTable__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                  },
                                  (v142/*: any*/),
                                  (v49/*: any*/),
                                  (v176/*: any*/),
                                  (v177/*: any*/),
                                  (v178/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v31/*: any*/)
                        ]
                      },
                      {
                        "args": (v175/*: any*/),
                        "filters": (v145/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorGroupedListViewPagination__groups",
                        "kind": "LinkedHandle",
                        "name": "groups"
                      }
                    ],
                    "type": "JiraGroupedListView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v180/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v144/*: any*/)
                      },
                      {
                        "args": (v180/*: any*/),
                        "filters": (v145/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorListViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ],
                    "type": "JiraListView"
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v28/*: any*/),
                "concreteType": "JiraJqlFieldWithAliases",
                "kind": "LinkedField",
                "name": "rankField",
                "plural": false,
                "selections": [
                  (v155/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v29/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectType"
                  },
                  (v45/*: any*/),
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "editIssues",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_ISSUES"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v181/*: any*/),
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "createIssues",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_ISSUES"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v181/*: any*/),
                        "storageKey": "action(type:\"CREATE_ISSUES\")"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "38eff953d5dc19b03e72c037d9f32dea3993ff719f8d7d1d780dac76ea6d62a5",
    "metadata": {},
    "name": "main_IssueNavigatorQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": isRefactorNinToViewSchemaEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": bulkOpsInNinEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": isIssueRankingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": isCheckIssueCreatePermissionsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider
    }
  }
};
})();

(node as any).hash = "6dc0a4b2ca0d834605bf564f2d4efc5c";

export default node;
